import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAudioTranscription,
  postAudioTranscriptionLocal,
} from "../../../../services/api/instances/audioTranscriptionApi/methods";
import type { RootState } from "../../../../services/redux/types";
import { getError } from "../../../../services/lib/getError";

export const postAudioFileAction = createAsyncThunk(
  "audioTranscription/postAudioFile",
  async (file: File, { rejectWithValue }) => {
    try {
      return await postAudioTranscriptionLocal(file as File);
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);

export const getAudioTranscriptionAction = createAsyncThunk(
  "audioTranscription/getAudioTranscription",
  async (_, ThunkApi) => {
    try {
      const { audioTranscriptionInfo } = (ThunkApi.getState() as RootState)
        .audioTranscriptionState;
      const signal = ThunkApi.signal;

      return await getAudioTranscription(
        audioTranscriptionInfo?.hash as string,
        signal,
      );
    } catch (e: unknown) {
      const message = getError(e);
      return ThunkApi.rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);
